module.exports = __webpack_public_path__ + "img/logo_scrapper.a4c0c7d9.png";